import styled from "styled-components"

export const Table = styled.table`
    position: relative;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: .5em;
    text-align: center;
    z-index: 1;
    margin: auto;
    width: 95%;
    min-width:95%;
`

export const TableBody = styled.tbody`  

`

export const TableRow = styled.tr`
  
`

export const TableHead = styled.th`
    vertical-align: middle;
    text-align: center;
    position: sticky;
    top: -.5px;
    color: ${({ theme }) => theme.colors.tableText};
    font-size: 2em;
    padding: .5em .5em;
    border: 1px solid ${({ theme }) => theme.colors.tableBorder};
    background-color: ${({ theme }) => theme.colors.tableHead};

    @media screen and (max-width:768px){
    font-size: 1em;
    }
`

export const TableCell = styled.td`
    border: 1px solid ${({ theme }) => theme.colors.tableBorder};
    color: ${({ theme }) => theme.colors.tableText};
    font-size: 2em;
    text-decoration: none;
    background-color: ${({ theme }) => theme.colors.tableCell};
    text-align: center;
    padding: .5em;
    cursor:pointer;
    font-weight:bold;

    &.active{
    background-color: ${({ theme }) => theme.colors.tableCellActive};
    }

    &.mild{
    color:${({ theme }) => theme.colors.mild};
    font-weight: bold;
    }

    &.moderate{
    color: ${({ theme }) => theme.colors.moderate};
    font-weight: bold;
    }

    &.high{
    color: ${({ theme }) => theme.colors.high};
    font-weight: bold;
    }

    &.urgent{
    color: ${({ theme }) => theme.colors.urgent};
    font-weight: bold;
    }

    &.cursor{
    cursor: pointer;
    }

    @media screen and (max-width:768px){
        font-size: 1.5em;
    }
    @media screen and (max-width:380px){
        font-size: 1em;
    }
`

export const TableContainer = styled.div`
    overflow:auto;
    width: 95%;
    margin:auto;
    margin-bottom:3%;
    margin-top: 2%;

    ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.trackColor};
    }

    ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.thumbColor};
    }

    ::-webkit-scrollbar-corner{
    background-color: ${({ theme }) => theme.colors.trackColor};
    }

    @media screen and (max-width:768px){
    width: 98%;
    }
`